import { apiClient } from './axios';

export interface Paginated<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}

interface ExecutionCallSummary {
  phone_number: string | null;
  call_transport: string | null;
  created_at: string;
}

interface ExecutionCallDetail extends ExecutionCallSummary {
  id: string;
  duration: number | null;
}

export interface QualityExecutionListItem {
  call_id: string;
  name: string;
  rubric_version: string;
  flags: Record<string, unknown>;
  data: Record<string, unknown>;
  confidence_score: number | null;
  assessed_at: string;
  quality_config: { id: string; name: string } | null;
  call: ExecutionCallSummary;
}

export interface QualityExecutionDetail extends Omit<QualityExecutionListItem, 'call'> {
  quality_config_id: string | null;
  reasoning: string | null;
  model_input: string | null;
  quality_config: {
    id: string;
    name: string;
    model_name: string;
    rubric_version: string;
  } | null;
  call: ExecutionCallDetail;
}

export interface ClassificationExecutionListItem {
  call_id: string;
  name: string;
  taxonomy_version: string;
  labels: Record<string, unknown>;
  data: Record<string, unknown>;
  confidence_score: number | null;
  classified_at: string;
  classifier_config: { id: string; name: string } | null;
  call: ExecutionCallSummary;
}

export interface ClassificationExecutionDetail extends Omit<
  ClassificationExecutionListItem,
  'call'
> {
  classifier_config_id: string | null;
  model_input: string | null;
  classifier_config: {
    id: string;
    name: string;
    model_name: string;
    taxonomy_version: string;
  } | null;
  call: ExecutionCallDetail;
}

export const agentExecutionsApi = {
  listQuality: async (page: number, pageSize: number) => {
    const response = await apiClient.get<Paginated<QualityExecutionListItem>>(
      '/agent-executions/quality',
      { params: { page, pageSize } },
    );
    return response.data;
  },
  getQuality: async (callId: string, name: string) => {
    const response = await apiClient.get<QualityExecutionDetail>(
      `/agent-executions/quality/${callId}/${encodeURIComponent(name)}`,
    );
    return response.data;
  },
  listClassifications: async (page: number, pageSize: number) => {
    const response = await apiClient.get<Paginated<ClassificationExecutionListItem>>(
      '/agent-executions/classifications',
      { params: { page, pageSize } },
    );
    return response.data;
  },
  getClassification: async (callId: string, name: string) => {
    const response = await apiClient.get<ClassificationExecutionDetail>(
      `/agent-executions/classifications/${callId}/${encodeURIComponent(name)}`,
    );
    return response.data;
  },
};
